import { Grid, Box, Button, makeStyles, TextField } from "@material-ui/core"
import { AssociatedOpenChannel } from "@root/store/types"
import React from "react"

export interface Props {
  onAssociate: (email: AssociatedOpenChannel) => void
}

const useStyles = makeStyles({
  button: {
    alignSelf: "center",
  },
})

const AssociatedOpen: React.FC<Props> = ({ onAssociate }) => {
  const [address, setAddress] = React.useState("")
  const [openPlatformName, setOpenPlatformName] = React.useState("")
  const classes = useStyles()

  return (
    <Box
      component="form"
      data-qa-selector="associated-open-form"
      onSubmit={(ev) => {
        ev.preventDefault()
        onAssociate({ platform: "open", address, openPlatformName })
        setAddress("")
      }}
    >
      <Grid container spacing={2}>
        <Grid item sm={5} xs={12}>
          <TextField
            required
            fullWidth
            data-qa-selector="open-platform-name-input"
            id="open-platform-name-id"
            label="Open Platform Name"
            value={openPlatformName}
            onChange={(ev) => setOpenPlatformName(ev.target.value)}
          />
        </Grid>
        <Grid item sm={5} xs={12}>
          <TextField
            required
            fullWidth
            data-qa-selector="address-input"
            id="address-id"
            label="Address"
            value={address}
            onChange={(ev) => setAddress(ev.target.value)}
          />
        </Grid>
        <Grid item sm={2} xs={12} className={classes.button}>
          <Button
            fullWidth
            data-qa-selector="submit"
            type="submit"
            variant="contained"
            className={classes.button}
            disabled={!address || !openPlatformName}
          >
            Register
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AssociatedOpen
